import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------ *\
 #TAB
\* ------------------------------------ */
:host(:focus-visible) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Tabs button
 */
.cat-c-tab__button {
  display: flex;
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  font-weight: normal;
  appearance: none;
  border-block-start: none;
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
  padding-block: var(--cat-space-small);
  padding-inline: var(--cat-space-medium);
  cursor: pointer;
  color: var(--cat-theme-color-content-default);
  text-align: center;
  text-decoration: none;
  background: none;
  justify-content: center;
  border-inline-end: none;
  border-inline-start: none;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  align-items: center;
  /**
   * Tabs button within disabled item
   * 1) Remove pointer events
   */
  /**
   * Tabs button with more padding than the default
   */
  /**
   * Tabs button within contrast control tabs
   */
  /**
   * Active tabs button
   */
  /**
   * Active tabs button within large tabs
   */
  /**
   * Active tabs button within contrast control tabs
   */
}
.cat-c-tab__button:hover {
  color: var(--cat-theme-color-content-default-hover);
  background: var(--cat-theme-color-background-subtle);
  border-color: var(--cat-theme-color-background-subtle);
}
.cat-c-tab__button:focus {
  color: var(--cat-theme-color-content-default);
  background-color: transparent;
  border-color: var(--cat-theme-color-background-strong);
}
.cat-c-tab.cat-is-disabled .cat-c-tab__button {
  color: var(--cat-theme-color-content-disabled);
  background-color: transparent;
  border-color: var(--cat-theme-color-border-disabled);
  cursor: not-allowed;
}
.cat-c-tab--large .cat-c-tab__button {
  font-family: var(--cat-theme-typography-label-lg-font-family);
  font-weight: var(--cat-theme-typography-label-lg-font-weight);
  font-size: var(--cat-theme-typography-label-lg-font-size);
  line-height: var(--cat-theme-typography-label-lg-line-height);
  font-weight: normal;
  padding-block: calc(var(--size-base-unit) * 2) calc(var(--size-base-unit) * 2 - 1px);
  padding-inline: calc(var(--size-base-unit) * 3);
}
.cat-c-tab--contrast .cat-c-tab__button {
  border-radius: var(--cat-border-radius-xl);
  padding: var(--cat-space-3x-small) var(--cat-space-x-large);
  border: none;
  font-weight: var(--cat-font-weight-semibold);
  color: var(--cat-theme-color-content-strong);
  display: flex;
  height: 100%;
  align-items: center;
}
.cat-c-tab--contrast .cat-c-tab__button:hover {
  background-color: var(--cat-theme-color-background-subtle-hover);
  color: var(--cat-theme-color-content-default);
}
.cat-c-tab.cat-is-active .cat-c-tab__button {
  background: var(--cat-theme-color-background-default);
  border-color: var(--cat-theme-color-border-brand);
  border-block-end-width: var(--cat-border-width-md);
  font-weight: var(--cat-font-weight-semibold);
  padding-block-end: calc(var(--cat-space-small) - 1.5px); /* Make border appear to be inside the tab */
}
.cat-c-tab.cat-is-active .cat-c-tab__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-tab.cat-c-tab--large.cat-is-active .cat-c-tab__button {
  padding-block-end: calc(var(--cat-space-medium) - 2px); /* Make border appear to be inside the tab */
}
.cat-c-tab.cat-c-tab--contrast.cat-is-active .cat-c-tab__button {
  background: var(--cat-theme-color-background-xstrong);
  color: var(--cat-theme-color-content-knockout);
  padding-block-end: var(--cat-space-3x-small);
  border-block-end: none;
  font-weight: var(--cat-font-weight-semibold);
  /* This media query applies styles only to devices that support hovering (like those with a mouse). 
     It avoids applying hover effects on touch devices (like tablets and smartphones
  */
}
@media (hover: hover) and (pointer: fine) {
  .cat-c-tab.cat-c-tab--contrast.cat-is-active .cat-c-tab__button:hover {
    background: var(--cat-theme-color-background-strong-hover);
    color: var(--cat-theme-color-content-knockout);
  }
}

.cat-c-tab__wrapper {
  min-height: calc(var(--size-base-unit) * 3);
  display: flex;
  align-items: center;
}

.cat-c-tab--full-width .cat-c-tab__button,
.cat-c-tab--responsive-full-width .cat-c-tab__button {
  width: 100%;
  height: 100%;
}

/**
 * Tabs list item
 */
.cat-c-tab {
  display: block;
  margin: 0;
  flex-shrink: 0;
  padding: 0;
  word-break: break-word;
  hyphens: auto;
  /**
   * Tabs item within responsive full width tabs
   * 1) Tabs take up equal widths within the 100% container on small screens
   */
}
@media all and (max-width: 35rem) {
  .cat-c-tab.cat-c-tab--responsive-full-width {
    flex: 1; /* 1 */
  }
}
.cat-c-tab.cat-c-tab--full-width {
  flex: 1; /* 1 */
}

.cat-c-tab--full-width {
  width: 100%;
}
`;
       